import { Dropdown } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import downarrow from '../assets/images/downarrow.svg'
import userImage from '../assets/images/user3.svg'
import { useLogoutMutation } from '../redux/api/authApi'
import baseApi from '../redux/api/baseApi'
import { logOut } from '../redux/slice/authSlice'

const Activity = () => {
  const { user, userToken } = useSelector((state) => state.auth)
  const [logout] = useLogoutMutation()

  const navigate = useNavigate()
  const dispatch = useDispatch()

  const handleLogout = async () => {
    try {
      await logout({ userToken }).unwrap()
      dispatch(logOut())
      dispatch(baseApi.util.resetApiState())
      navigate('/login')
    } catch (error) {
      console.log(error)
    }
  }

  return (
    <div className='activity-container' style={{ minWidth: '100px' }}>
      <div className='profile-container profile-item' style={{ minWidth: '125px' }}>
        <div className='nav-item dropdown' style={{ width: '100%' }}>
          <Dropdown>
            <Dropdown.Toggle style={{ width: '100%' }}>
              <figure className='profile-image' style={{ width: '100%' }}>
                <img src={userImage} alt='user4' />
                <div className='d-flex justify-content-between' style={{ width: '100%' }}>
                  <figcaption>{user.name}</figcaption>
                  <img src={downarrow} className='downarrow' alt='downarrow' />
                </div>
              </figure>
            </Dropdown.Toggle>
            <Dropdown.Menu>
              <Dropdown.Item onClick={handleLogout}>Logout</Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>
      </div>
    </div>
  )
}

export default Activity
